module.exports = __webpack_public_path__ + "img/PASC.a94576cd.svg";